export const navigationState = {
  isExternalNavigation: false,
}

export const setIsExternalNavigation = (externalNavigation = true): void => {
  navigationState.isExternalNavigation = externalNavigation
}

export const navigateToExternalUrl = (url: string | URL): void => {
  try {
    navigationState.isExternalNavigation = true
    // eslint-disable-next-line no-restricted-syntax
    window.location.replace(url)
  } catch (e) {
    navigationState.isExternalNavigation = false
    throw e
  }
}
